import { Fragment } from "react";
import { DashboardStats } from "@/lib/api/mentor-scoring.ts";

interface Stats {
  data: DashboardStats;
}

export function Stats({ data }: Stats) {
  const stats = [
    {
      title: "Total Mentors",
      value: `${data.totalMentors ? data.totalMentors : "-"}`,
    },
    { title: "Total Bonus Payouts", value: `$${data.totalBonusPayouts} ` },
    { title: "Avg. Bonus per Mentor", value: `${data.avgBonusPerMentor.toFixed(2)} ` },
    {
      title: "Total Paid Engagements",
      value: data.totalPaidEngagements
    },
  ];

  return (
    <div className="inline-flex h-24 w-full items-center justify-start rounded-xl border border-neutral-200">
      {stats.map((stat, index) => (
        <Fragment key={index}>
          <div className="inline-flex shrink grow basis-0 flex-col items-center justify-center gap-2 p-3">
            <div className="self-stretch text-center text-xs font-normal leading-tight text-black">
              {stat.title}
            </div>
            <div className="text-center text-base font-bold leading-tight text-black">
              {stat.value}
            </div>
          </div>
          {index !== stats.length && (
            <div className="flex w-px items-start justify-start self-stretch">
              <div className="relative h-24 w-px rounded-full bg-neutral-200" />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
